import { PropertyType } from './property-type.interface';

export default {
   async delete(property_type_id: number) {
      return await api.delete(`/property-type/${property_type_id}`);
   },
   async post(body: PropertyType) {
      return await api.post('/property-type?include=properties.city', body).then((response) => response.data);
   },
   async patch(property_type_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api.patch(`/property-type/${property_type_id}`, body).then((response) => response);
   },
};
